import handleFetchErrors from '../utils/handleFetchErrors';
const fileUrl = process.env.REACT_APP_SEARCH_OPTIONS_VER_API;
const newProductWallVersionsUrl = process.env.REACT_APP_NEW_PW_VERSIONS_API;
const searchOptionsUrl = process.env.REACT_APP_SEARCH_SELECT_OPTIONS_API;

class SearchOptionsVersionClient {
  async getAll(): Promise<SearchOptionsVersion[]> {
    return fetch(fileUrl as unknown as URL)
      .then(handleFetchErrors)
      .then((res) =>
        res.json().catch((err) => {
          console.error('search options version file is not valid JSON', err);
          return [];
        }),
      );
  }
  async getNewProductWallVersions(): Promise<SearchOptionsVersion[]> {
    return fetch(newProductWallVersionsUrl as unknown as URL)
      .then(handleFetchErrors)
      .then((res) =>
        res.json().catch((err) => {
          console.error('search options version file is not valid JSON', err);
          return [];
        }),
      );
  }
  async getAllSearchOptions(): Promise<SearchSelect[]> {
    return await fetch(searchOptionsUrl as unknown as URL)
      .then(handleFetchErrors)
      .then((res) =>
        res.json().catch((err) => {
          console.error('search options file is not valid JSON', err);
          return [];
        }),
      );
  }
}

export default new SearchOptionsVersionClient();
